import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { AnimatePresence, motion } from 'framer-motion';
import { ArrowRightIcon, ChevronRightIcon, XIcon } from 'lucide-react';
import { livingNav, mainNav } from '../../data/navigation';
import { categories } from '../../data/collections';
import type { Line } from '../../types/product';
import { Logo } from '../brand/Logo';
const ease = [0.23, 1, 0.32, 1] as const;
type MobileMenuProps = {
  open: boolean;
  onClose: () => void;
  line?: Line;
};
export function MobileMenu({
  open,
  onClose,
  line = 'beauty'
}: MobileMenuProps) {
  const living = line === 'living';
  const nav = living ? livingNav : mainNav;
  useEffect(() => {
    if (!open) return;
    const onKey = (e: KeyboardEvent) => e.key === 'Escape' && onClose();
    window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
  }, [open, onClose]);
  return <AnimatePresence data-id="element-264" data-mp="qkykv8rnwnuc">
      {open && <div className="fixed inset-0 z-50 lg:hidden" data-id="element-265" data-mp="qjvt6ymimhdd">
          <motion.div className="absolute inset-0 bg-ink/40" initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} exit={{
        opacity: 0
      }} transition={{
        duration: 0.2
      }} onClick={onClose} data-id="element-266" data-mp="5aigeu53lb8" />
          <motion.aside role="dialog" aria-modal="true" aria-label="Menu" className="absolute inset-y-0 left-0 flex w-[86%] max-w-sm flex-col overflow-y-auto bg-white" initial={{
        x: '-100%'
      }} animate={{
        x: 0
      }} exit={{
        x: '-100%'
      }} transition={{
        duration: 0.25,
        ease
      }} data-id="element-267" data-mp="dxibbviays4n">
            <div className="flex h-16 items-center justify-between border-b border-line px-5" data-id="element-268" data-mp="3mfwl4ayv9b7u">
              <Logo size="sm" sub={living ? 'LIVING' : 'BEAUTY'} data-id="element-269" data-mp="3raa7xozgqa0w" />
              <button onClick={onClose} className="grid h-10 w-10 place-items-center" aria-label="Menu sluiten" data-id="element-270" data-mp="11mjf35g6xf3l">
                <XIcon className="h-5 w-5" data-id="element-271" data-mp="16kkvfim8f0bd" />
              </button>
            </div>
            <ul className="px-5 py-3" data-id="element-272" data-mp="32o96qkijyf22">
              {nav.map(item => <li key={item.to} data-id="element-273" data-mp="2yoqiberivluh">
                  <Link to={item.to} onClick={onClose} className={`flex items-center justify-between border-b border-line py-4 ${living ? 'text-lg font-semibold' : 'text-sm font-semibold uppercase tracking-[0.12em]'}`} data-id="element-274" data-mp="2ynp7nbef51da">
                    {item.label}
                    <ChevronRightIcon className="h-4 w-4 text-muted" data-id="element-275" data-mp="2f1apvlqit53m" />
                  </Link>
                </li>)}
            </ul>
            {!living && <>
                <p className="px-5 pt-4 text-xs font-medium text-muted" data-id="element-276" data-mp="2ox49fp2npyuw">Per categorie</p>
                <ul className="flex flex-wrap gap-2 px-5 py-3" data-id="element-277" data-mp="217t5xztx9qd2">
                  {categories.map(c => <li key={c.id} data-id="element-278" data-mp="1w8gnrsdzx7gt">
                      <Link to={`/collectie/${c.id}`} onClick={onClose} className="block border border-line px-3.5 py-1.5 text-sm" data-id="element-279" data-mp="1w7du5cpagqx7">
                        {c.title}
                      </Link>
                    </li>)}
                </ul>
              </>}
            <div className="mt-auto border-t border-line px-5 py-5" data-id="element-280" data-mp="2slyacfs6uxn">
              <Link to={living ? '/' : '/living'} onClick={onClose} className={`flex items-center justify-between font-semibold ${living ? 'text-pink' : 'text-majorelle'}`} data-id="element-281" data-mp="6te7x6skf1ug">
                Naar {living ? 'AMIRA Beauty' : 'AMIRA Living'}
                <ArrowRightIcon className="h-4 w-4" data-id="element-282" data-mp="lg7i5xn89hfs" />
              </Link>
              <Link to="/over-amira" onClick={onClose} className="mt-4 block text-sm text-muted" data-id="element-283" data-mp="qfu3kud7m3zo">
                Ons verhaal
              </Link>
            </div>
          </motion.aside>
        </div>}
    </AnimatePresence>;
}